import { useState, useEffect } from "react";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../../firebase";
import { CLUB_ID, THEME_COLOR } from "../../config/club";
import Swal from "sweetalert2";

export default function EditReservationModal({ show, onClose, reservation }) {
    const [form, setForm] = useState({
        name: "",
        date: "",
        startTime: "",
        endTime: "",
        maxSlots: 0,
        status: "open"
    });

    useEffect(() => {
        if (reservation) {
            setForm({
                name: reservation.name || "",
                date: reservation.date || "",
                startTime: reservation.startTime || "",
                endTime: reservation.endTime || "",
                maxSlots: reservation.maxSlots || 0,
                status: reservation.status || "open"
            });
        }
    }, [reservation]);

    if (!show || !reservation) return null;

    const handleSave = async () => {
        try {
            await updateDoc(
                doc(db, "clubs", CLUB_ID, "reservations", reservation.id),
                {
                    ...form,
                    maxSlots: Number(form.maxSlots)
                }
            );

            Swal.fire("Updated", "Reservation updated successfully", "success");
            onClose();
        } catch (err) {
            console.error(err);
            Swal.fire("Error", "Failed to update", "error");
        }
    };

    return (
        <div className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
            style={{ background: "rgba(0,0,0,0.6)", zIndex: 1060 }}>

            <div className="bento-card p-4 shadow-lg border-0 m-3 animate__animated animate__zoomIn" style={{ width: "100%", maxWidth: 500 }}>

                <h5 className="fw-bold mb-3" style={{ color: THEME_COLOR }}>
                    Edit Reservation
                </h5>

                {/* FORM */}
                <div className="d-flex flex-column gap-2">

                    <input
                        className="form-control"
                        placeholder="Name"
                        value={form.name}
                        onChange={(e) => setForm({ ...form, name: e.target.value })}
                    />

                    <input
                        type="date"
                        className="form-control"
                        value={form.date}
                        onChange={(e) => setForm({ ...form, date: e.target.value })}
                    />

                    <div className="d-flex gap-2">
                        <input
                            type="time"
                            className="form-control"
                            value={form.startTime}
                            onChange={(e) => setForm({ ...form, startTime: e.target.value })}
                        />
                        <input
                            type="time"
                            className="form-control"
                            value={form.endTime}
                            onChange={(e) => setForm({ ...form, endTime: e.target.value })}
                        />
                    </div>

                    <input
                        type="number"
                        className="form-control"
                        placeholder="Max Slots"
                        value={form.maxSlots}
                        onChange={(e) => setForm({ ...form, maxSlots: e.target.value })}
                    />

                    <select
                        className="form-select"
                        value={form.status}
                        onChange={(e) => setForm({ ...form, status: e.target.value })}
                    >
                        <option value="open">Open</option>
                        <option value="full">Full</option>
                        <option value="closed">Closed</option>
                    </select>

                </div>

                {/* ACTIONS */}
                <div className="d-flex justify-content-end gap-2 mt-4">
                    <button className="btn btn-light" onClick={onClose}>
                        Cancel
                    </button>
                    <button
                        className="btn text-white"
                        style={{ backgroundColor: THEME_COLOR }}
                        onClick={handleSave}
                    >
                        Save Changes
                    </button>
                </div>
            </div>
        </div>
    );
}